import { QueryClient, QueryClientProvider } from 'react-query';

const queryClient = new QueryClient();

const Provider = ({ children }) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);

export default Provider;
